import React from 'react';
import { toggleBucket } from './util';
import cookieMonsterIcon from '../../images/cookie-monster.svg';
import styles from './AltBucketToast.css';
import { getCookie } from '../../utils/cookie';
import getConfig from '../../config';

const AltBucketToast = () => {
    const cookieSet = getCookie('stageval');
    const version = getConfig('version');

    return (
        <div role="dialog" className="alt-bucket-toast">
            <div>
                Version: {version} {cookieSet && '(SECONDARY)'}
            </div>
            <button
                className="toggle-cookie"
                type="button"
                onClick={toggleBucket}
            >
                <div>
                    <img
                        width="30px"
                        height="30px"
                        alt="cookie-monster"
                        src={cookieMonsterIcon}
                    />
                </div>

                <div>{cookieSet ? 'Remove cookie' : 'Set cookie'}</div>
            </button>
            <style jsx>{styles}</style>
        </div>
    );
};

export default AltBucketToast;
